import { Sparkles } from "lucide-react";
import Link from "next/link";

import { cn } from "@/lib/utils";

/**
 * Marca do escritório. Quando existe logotipo cadastrado, ele aparece sozinho —
 * como no site anterior, onde a barra do topo traz apenas a marca. Sem
 * logotipo, cai no ícone com o nome ao lado.
 */
export function Logo({
  siteName,
  logoUrl,
  className,
}: {
  siteName: string;
  logoUrl?: string | null;
  className?: string;
}) {
  return (
    <Link
      href="/"
      aria-label={`${siteName} — início`}
      className={cn("inline-flex items-center gap-2.5", className)}
    >
      {logoUrl ? (
        // eslint-disable-next-line @next/next/no-img-element
        <img src={logoUrl} alt={siteName} className="h-9 w-auto md:h-10" />
      ) : (
        <>
          <span className="flex size-9 shrink-0 items-center justify-center rounded-xl bg-royal text-paper">
            <Sparkles className="size-4.5" aria-hidden />
          </span>
          <span className="text-base font-semibold tracking-tight text-paper">
            {siteName}
          </span>
        </>
      )}
    </Link>
  );
}
